// German for the client library: verbs, folder chips, the table and the librarian's toasts.
import { registerDe } from '../i18n/index.js';

registerDe({
  'Documents enter the library through an engagement — create one first.': 'Dokumente gelangen über einen Auftrag in die Bibliothek — legen Sie zuerst einen an.',
  '{n} added to the library': '{n} in die Bibliothek aufgenommen',
  '{n} already on file': '{n} bereits abgelegt',
  '{n} not accepted': '{n} nicht akzeptiert',
  'Librarian finished — {n} document(s) classified': 'Bibliothekar fertig — {n} Dokument(e) klassifiziert',
  'the': 'die',
  'Librarian finished — the library is filed.': 'Bibliothekar fertig — die Bibliothek ist abgelegt.',
  'The librarian is not installed yet — classification arrives with the next release.': 'Der Bibliothekar ist noch nicht installiert — die Klassifikation kommt mit dem nächsten Release.',
  'Library': 'Bibliothek',
  'Classify every document — folder, tags, one-line summary. Auto-applied, always yours to correct.': 'Jedes Dokument klassifizieren — Ablage, Tags, Einzeiler. Automatisch übernommen, jederzeit von Ihnen korrigierbar.',
  'Classifying…': 'Wird klassifiziert…',
  'Run librarian': 'Bibliothekar starten',
  'New uploads enter the library through this engagement': 'Neue Uploads gelangen über diesen Auftrag in die Bibliothek',
  'via {code}': 'über {code}',
  'Add files to the client library': 'Dateien in die Kundenbibliothek aufnehmen',
  'Documents enter the library through an engagement — create one first': 'Dokumente gelangen über einen Auftrag in die Bibliothek — legen Sie zuerst einen an',
  'Uploading…': 'Wird hochgeladen…',
  'Upload': 'Hochladen',
  'All': 'Alle',
  'unclassified': 'nicht klassifiziert',
  'No documents match this filter': 'Keine Dokumente entsprechen diesem Filter',
  'The library is empty': 'Die Bibliothek ist leer',
  'Pick another folder, or All.': 'Wählen Sie eine andere Ablage oder «Alle».',
  'Upload here, or ingest on the Documents page of an engagement — everything lands in this library.': 'Hier hochladen oder auf der Dokumentseite eines Auftrags einlesen — alles landet in dieser Bibliothek.',
  'Ref': 'Ref',
  'Document': 'Dokument',
  'Folder': 'Ablage',
  'Used by': 'Verwendet von',
  'Evidence citations across all engagements': 'Beleg-Zitate über alle Aufträge',
  '{n}× cited': '{n}× zitiert',
  'library only': 'nur Bibliothek',
  'uploaded here': 'hier hochgeladen',
  'linked from library': 'aus der Bibliothek verknüpft',
  // document status badges (r.status)
  'processing': 'in Verarbeitung',
  'ready': 'bereit',
  'failed': 'fehlgeschlagen',
  'superseded': 'ersetzt',
  // DOCUMENT_FOLDERS — the folder chips
  'correspondence': 'Korrespondenz',
  'meeting': 'Besprechung',
  'agreement': 'Vereinbarung',
  'financial': 'Finanzen',
  'specification': 'Spezifikation',
  'presentation': 'Präsentation',
  'image': 'Bild',
  'note': 'Notiz',
  'deliverable': 'Arbeitsergebnis',
  'reference': 'Referenz',
}, 'ClientLibrary');
